module.exports = __webpack_public_path__ + "static/media/puzzle-19-bg.0a004942.svg";